<template>
  <headroom :z-index="1000">
    <header class="app__nav" :class="{ 'app__nav--collapse': collapseMenu }">
      <div class="app__nav__mask"></div>
      <div class="app__nav__container">
        <div class="clearfix app__nav__container__main">
          <router-link class="app__nav__container__main__brand" :to="{'name': 'overview'}">
            <div class="sr-only">
              ICIJ
            </div>
          </router-link>
          <button class="btn btn-link btn-lg float-right mt-2 app__nav__container__main__hamburger" @click="toggleMenu()">
            <i class="fa fa-bars fa-2x"></i>
          </button>
        </div>
        <ul class="app__nav__container__menu list-unstyled" :class="{ 'app__nav__container__menu--collapse': collapseMenu }">
          <li class="list-unstyled-item app__nav__container__menu__item">
            <a href="https://www.icij.org/investigations/paradise-papers/" target="_blank">
              Paradise Papers <i class="fa fa-external-link ml-1 app__nav__container__menu__item__new"></i>
            </a>
          </li>
          <li class="list-unstyled-item app__nav__container__menu__item">
            <a href="https://offshoreleaks.icij.org" target="_blank">
              Offshore Leaks <i class="fa fa-external-link ml-1 app__nav__container__menu__item__new"></i>
            </a>
          </li>
          <li class="list-unstyled-item app__nav__container__menu__item">
            <a href="https://www.icij.org/" target="_blank">
              ICIJ <i class="fa fa-external-link ml-1 app__nav__container__menu__item__new"></i>
            </a>
          </li>
          <li class="list-unstyled-item app__nav__container__menu__item app__nav__container__menu__item--share">
            <share class="text-left p-3"></share>
          </li>
        </ul>
      </div>
    </header>
  </headroom>
</template>

<script>
import Share from './Share.vue'
import { headroom } from 'vue-headroom'

export default {
  name: 'AppNav',
  components: {
    Share,
    headroom
  },
  data () {
    return {
      collapseMenu: true
    }
  },
  methods: {
    toggleMenu () {
      this.collapseMenu = !this.collapseMenu
    }
  }
}
</script>

<style lang="scss">
  .app__nav {
    z-index: $zindex-fixed;
    position: relative;
    width:100%;
    color:white;
    width: auto;
    min-height: $app-nav-height;
    background: darken(theme-color('cuttysark'), 0);
    box-shadow: 0 0 5px rgba(black, 0.4);

    &--collapse, &--collapse &__container__main {
      transition: background 600ms, box-shadow 600ms;

      .headroom--top & {
        box-shadow: 0 0 5px rgba(black, 0);
        background: transparent;

        &:before {
          @include media-breakpoint-down(md) {
            transform: translateX(-200%)
          }
        }
      }
    }

    &__container {

      &__main {

        position:relative;
        z-index: $zindex-fixed + 30;
        background: theme-color('cuttysark');
        min-height: $app-nav-height;

        &:before {
          content:"";
          background: url('~images/icij-white@2x.png') no-repeat 0 0;
          background-size: cover;
          width: $app-nav-brand-height;
          height: $app-nav-brand-height;
          position: absolute;
          top: $spacer;
          left: $spacer;
          z-index: $zindex-fixed + 20;
          border:1px solid white;
        }

        &__brand, &__brand:hover, &__brand:focus {
          color: inherit;
          display: inline-block;
          padding:$spacer ;
          padding-left: $app-nav-brand-height + $spacer * 2;
          pointer-events: auto;

          & > * {
            font-size: 2rem;
            display: inline-block;
            line-height: $line-height-base;
          }
        }

        &__hamburger {
          cursor: pointer;
          color: inherit;
          pointer-events: auto;
        }
      }


      &__menu {
        z-index: $zindex-fixed + 20;
        position: absolute;
        top:100%;
        left:0;
        right:0;
        clear:both;
        margin:0;
        background: darken(theme-color('cuttysark'), 10);

        &:after {
          z-index:10;
          transition: opacity 400ms;
          position: absolute;
          top:100%;
          height: 3rem;
          left:0;
          right:0;
          content:"";
          @include gradient-y(rgba(black, 0.2), rgba(black, 0));
        }

        &--collapse,
        .headroom--unpinned & {
          transform: translateY(-150%);
          &:after {
            opacity: 0;
          }
        }

        &__item {
          border-bottom: 1px solid rgba(white, 0.1);

          & > a {
            display: block;
            padding: $spacer;
            color: white;

            &:hover {
              background: rgba(white, 0.1);
            }
          }

          &__new {
            color: rgba(white, 0.2);
          }

          .share {
            text-align: left;
            color: inherit;
            font-family: inherit;
            font-weight: normal;
            text-transform: none;

            &__list__item a.share__list__item__link:hover,
            &__list__item .share__list__item__link:hover {
              color: rgba(white, 0.5);
              border-color: rgba(white, 0.5);
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// AppNav.vue?832b9602